import ajax from '@/lib/ajax'

// 删除预约随访记录
export async function DeleteAppoinment(payload: any){
	let res = await ajax.delete('/api/services/app/FollowUpAppointment/DeleteAppoinment', {params:payload})
	return res.data.result
}

// 预约随访记录批量删除
export async function BatchDeleteAppoinment(payload: any){
	let res = await ajax.post('/api/services/app/FollowUpAppointment/BatchDeleteAppoinment', payload)
	return res.data.result
}

// 预约随访记录批量粘贴
export async function BatchPasteAppoinment(payload: any){
	let res = await ajax.post('/api/services/app/FollowUpAppointment/BatchPasteAppoinment', payload)
	return res.data.result
}

// 预约随访记录保存
export async function SaveAppoinment(payload: any){
	let res = await ajax.post('/api/services/app/FollowUpAppointment/SaveAppoinment', payload)
	return res.data.result
}
// 预约随访记录保存
export async function BatchSaveAppoinment(payload: any){
	let res = await ajax.post('/api/services/app/FollowUpAppointment/BatchSaveAppoinment', payload)
	return res.data.result
}

// 判断患者是否可以随访
export async function AllowInsertFollowForm(patientId: any){
	let res = await ajax.get("/api/services/app/FollowUpAppointment/AllowInsertFollowForm?patientId=" +patientId);
	return res.data.result
}


// WEBPACK FOOTER //
// ./src/api/follow/followUpAppointment/index.ts